import { Record } from 'immutable';

// Copied from Atlaskit's BreadcrumbsItem

export const makeBreadcrumbItemData = Record({
  actionSubjectId: '',
  hasSeparator: undefined,
  href: undefined,
  iconBefore: undefined,
  iconAfter: undefined,
  onClick: undefined,
  text: '',
  truncationWidth: undefined,
  target: undefined,
  component: undefined
});